import $ from 'jquery';
import './foundation.js';
import { responsiveEmbeds } from './responsive-embeds.js';
import { hero } from './hero.js';
import { cookieNotice } from './cookie-notice.js';
import { fiftyfifty } from './fitfyfifty.js';
import { menu } from './menu.js';

$(document).ready(function() {
	$(document).foundation();
	
	responsiveEmbeds();
	hero();
	cookieNotice();
	fiftyfifty();
	menu();
});

$('html').removeClass('no-js')	
				 .addClass('js');